import Manage from "./Manage";

export { default as loginSaga } from "./pages/login/Login.saga";

export default Manage;
